<template>
  <detail envName="养殖环境"
    :envInfoType='2' />
</template>

<script>
import Detail from '@/components/business/traceinfo/detail'
export default {
  name: 'breed-env-detail',
  components: { Detail },
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {},
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
